module.exports = __webpack_public_path__ + "img/hiag.2a03204e.jpeg";